<!--  -->
<template>
  <div class="cold-humidity">
    <div id="coldTemperatureChartRight" style="height: 100%; width: 98%"></div>
  </div>
</template>

<script>
import charts from "echarts";
import API from "../api/index";
export default {
  data() {
    return {
      coldTemperatureChartRight: null,
      coldTemperatureChartOption: {},
      xAxisData: [],
      listData: [],
    };
  },
  mounted() {
    var self = this;

    self.coldTemperatureChartRight = charts.init(
      document.getElementById("coldTemperatureChartRight")
    );
    self.queryData().then((res) => {
      self.initChart();
    });
  },

  methods: {
    queryData() {
      return new Promise((resolve, reject) => {
        this.$fetch(API.statAvgTemperatureAndhumidity, { statType: "1" }).then(
          (res) => {
            if (res.success) {
              res.returnObj.forEach((item, index) => {
                this.xAxisData.push(item.hours);
                if (index == 0) {
                  for (let key in item.dataMap) {
                    this.listData.push({
                      name: key,
                      list: [],
                    });
                  }
                }
              });
              res.returnObj.forEach((item) => {
                for (let key in item.dataMap) {
                  this.listData = this.listData.map((el, inde) => {
                    let re = {
                      name: el.name,
                      list: [...el.list],
                    };
                    if (el.name === key) {
                      re.list.push(item.dataMap[key]);
                    }
                    return re;
                  });
                }
              });
              resolve(this.listData);
            } else {
              this.$message.error(res.msgContent);
            }
          }
        );
      });
    },
    initChart() {
      const color = [
        "#FFDA00",
        "#228B22",
        "#FB4CD3",
      ];
      const yDatas = [];
      const rightData = this.listData.slice(3, this.listData.length)
      rightData.forEach((item, index) => {
        yDatas.push({
          name: item.name,
          type: "line",
          lineStyle: {
            normal: {
              color: color[index],
              width: 2,
            },
          },
          data: rightData[index].list,
        });
      });
      const option = {
        color: color,
        legend: {
          icon: "rect",
          itemHeight: 6,
          itemWidth: 6,
          textStyle: {
            color: "#ffffff",
          },
          right: 0,
          top: 0,
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 50,
          left: 10,
          bottom: 10,
          right: 30,
          containLabel: true,
        },
        xAxis: [
          {
            name: "时",
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#E4F5FD",
              },
            },
            data: this.xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：℃",
            axisLabel: {
              textStyle: {
                color: "#E4F5FD",
              },
            },
            nameTextStyle: {
              color: "#E4F5FD",
              fontSize: 12,
              lineHeight: 40,
              padding: [0, 0, 0, 30]
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: yDatas,
      };
      this.coldTemperatureChartRight = charts.init(
        document.getElementById("coldTemperatureChartRight")
      );
      this.coldTemperatureChartRight.setOption(option);
    },
  },
};
</script>

<style lang='scss' scoped>
.cold-humidity {
  height: 100%;
}
</style>